{
  "aboutCluster": "Om nettverket",
  "businessCode": "Næringskode (juridisk eier)",
  "businessCodeInfoText": "Denne fylles inn automatisk når organisasjonummer på juridisk eier blir fylt ut.",
  "cluster": "Klyngen",
  "clusterManagement": "Ledelse",
  "clusterName": "Navn",
  "clusterStatus": "Status",
  "dateOfFoundation": "Stiftelsesdato",
  "legalOwner": "Juridisk eier",
  "legalOwnerOrgnumber": "Organisasjonsnummer til juridisk eier",
  "mainContact": "Hovedkontakt",
  "membershipFee": "Medlemskontigent",
  "statistics.inKindCost": "Totalkost på egeninnsats for medlemmer over tid",
  "statistics.live": "Live statistikk",
  "yourProfile": "Profilen din"
}
